"use strict";

import _classCallCheck from "/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { getAddress } from "@ethersproject/address";
import { hexZeroPad } from "@ethersproject/bytes";
import { Coder } from "./abstract-coder";
export var AddressCoder = /*#__PURE__*/function (_Coder) {
  _inherits(AddressCoder, _Coder);

  var _super = _createSuper(AddressCoder);

  function AddressCoder(localName) {
    _classCallCheck(this, AddressCoder);

    return _super.call(this, "address", "address", localName, false);
  }

  _createClass(AddressCoder, [{
    key: "defaultValue",
    value: function defaultValue() {
      return "0x0000000000000000000000000000000000000000";
    }
  }, {
    key: "encode",
    value: function encode(writer, value) {
      try {
        getAddress(value);
      } catch (error) {
        this._throwError(error.message, value);
      }

      return writer.writeValue(value);
    }
  }, {
    key: "decode",
    value: function decode(reader) {
      return getAddress(hexZeroPad(reader.readValue().toHexString(), 20));
    }
  }]);

  return AddressCoder;
}(Coder);